import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SingleChoiceField from './SingleChoiceField';

const SingleChoice = ({ field, applications, groupByDistricts, districts, disabled }) => (
  <Field
    name={field}
    component={SingleChoiceField}
    values={applications}
    groupByDistricts={groupByDistricts}
    districts={districts}
    disabled={disabled}
  />
);

SingleChoice.propTypes = {
  field: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

export default SingleChoice;


// WEBPACK FOOTER //
// ./src/components/budget/types/SingleChoice.js